import { createStyles, makeStyles } from '@material-ui/core/styles'

export const errorBoundaryStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      minHeight: '100vh',
      textAlign: 'center'
    },

    logo: {
      marginBottom: 56
    },

    subTitle: {
      marginBottom: 40
    }
  })
)
